module.exports = __webpack_public_path__ + "img/noimage_en-US.18fe4a9b.png";